import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=e3695de8&scoped=true&"
import script from "./zone.vue?vue&type=script&lang=js&"
export * from "./zone.vue?vue&type=script&lang=js&"
import style0 from "./zone.vue?vue&type=style&index=0&id=e3695de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3695de8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
